import { render, staticRenderFns } from "./StatusNotificationSetting.vue?vue&type=template&id=3d1f446c&scoped=true&"
import script from "./StatusNotificationSetting.vue?vue&type=script&lang=js&"
export * from "./StatusNotificationSetting.vue?vue&type=script&lang=js&"
import style0 from "./StatusNotificationSetting.vue?vue&type=style&index=0&id=3d1f446c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f446c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VImg,VProgressCircular,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2687757686/src/ueyes-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1f446c')) {
      api.createRecord('3d1f446c', component.options)
    } else {
      api.reload('3d1f446c', component.options)
    }
    module.hot.accept("./StatusNotificationSetting.vue?vue&type=template&id=3d1f446c&scoped=true&", function () {
      api.rerender('3d1f446c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/StatusNotificationSetting.vue"
export default component.exports